module.exports = __webpack_public_path__ + "img/pause.98b395d6.svg";